module.exports = __webpack_public_path__ + "img/car-compare.7cbeab0.png";